module.exports = __webpack_public_path__ + "./static/img/icon-5.f05fc1971672b85834ed37bbcc842699.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/join/icon-5.png
// module id = ./client/src/assets/img/join/icon-5.png
// module chunks = 0